import { Suspense, useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { bhajanHtml } from "~/data/recipeBhajanViewData";
import { useFontStyle } from "~/hook/useFontStyle";
import { useLanguageParams } from "~/hook/useLanguageParams";
import useStopCurrentRunningVideoAudio from "~/hook/useStopCurrentRunningVideoAudio";
import { getSession } from "~/lib/helperFuncation/sessionStorageService";
import { getYoutubeVideoThumbnail } from "~/lib/helperFuncation/youtubeThumbnails";
import { onPauseVideo, setCurrentVideoPosition } from "~/lib/store/slice/youtubePlayerSlice";
import { useAppDispatch, useAppSelector } from "~/lib/store/store";
import { cn } from "~/lib/utils";
import { FALLBACK_IMAGE_URL, VIDEO_PLAYER, youtubeLinkPrefix } from "~/utils/constant";
import ClientOnly from "../shared-components/ClentOnly";
import { MdPlayArrow } from "react-icons/md";
import { changeIsAudioPlayState } from "~/lib/store/slice/audioSlice";

function RecipeBhajanView() {
  const playerRef = useRef<ReactPlayer | null>(null);

  const dispatch = useAppDispatch();
  const [updatedBhajanHtml, setUpdatedBhajanHtml] = useState<string>("");
  const [isPlaying, setIsPlaying] = useState(false);
  const { medium, normalInter } = useFontStyle();

  const { playCurrentVideo, removeVideoPlay } = useStopCurrentRunningVideoAudio();
  const { isVideoPlay, isFullScreen, currentVideoPosition } = useAppSelector((state) => state.youtubeVideo);
  const { is_annkut_audio_playing } = useAppSelector((state) => state.nityNiyam);

  const lang = useLanguageParams();
  const videoId = "eNDQct1ZmPc";
  const currentVideoPlay = getSession(VIDEO_PLAYER.CURRENT_VIDEO)?.videoId;

  function modifyIngredientHTML(html: string) {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;

    const anchors = wrapper.querySelectorAll("a");
    const paragraph = wrapper.querySelectorAll("p");
    const headings = wrapper.querySelectorAll("h3");
    const maindiv = wrapper.querySelector("div.thallyrics");
    const div = wrapper.querySelector("div.doha-mistan");

    anchors.forEach((a) => {
      const id = a.getAttribute("data-id");
      a.classList.add("text-textHeadingColor");
      a.href = `/${lang}/thal/${id}`;
    });

    paragraph.forEach((p) => {
      p.classList.add("text-align-last-justify", "text-justify", "w-full", "leading-7");
    });

    headings.forEach((h3) => {
      h3.classList.add("text-center", "text-textColor", "font-bold", "m-2", "text-2xl");
    });

    maindiv?.classList.add("flex", "flex-col", "justify-center", "items-center", "w-full", "text-lg");
    div?.classList.add("mx-auto", "w-fit", "text-lg", "lg:w-[75%]");

    return wrapper.innerHTML;
  }

  const handlePlayVideo = () => {
    playCurrentVideo(videoId);
    setIsPlaying(true);
    dispatch(onPauseVideo());
    removeVideoPlay();
    dispatch(changeIsAudioPlayState(false));
    // dispatch(setCurrentVideo(buildVideoData() as any));
  };

  const handlePauseVideo = () => {
    setIsPlaying(false);
  };

  const buildVideoData = () => ({
    id: null,
    videoId: videoId,
    from: "/thal",
    name: "Annakut Aarogo",
    duration: null,
    thumbnailUrl: getYoutubeVideoThumbnail(videoId!, "medium") || FALLBACK_IMAGE_URL,
  });

  useEffect(() => {
    if (bhajanHtml) {
      const ing = modifyIngredientHTML(bhajanHtml);
      setUpdatedBhajanHtml(ing);
    }

    // return () => {
    //   playCurrentVideo(videoId);
    //   <YoutubeVideoPlayer handlePlayVideo={() => playCurrentVideo(videoId)} videoId={videoId} />;
    // };
  }, []);

  useEffect(() => {
    if (isVideoPlay) {
      setIsPlaying(false);
    }
  }, [isVideoPlay]);

  useEffect(() => {
    if (is_annkut_audio_playing) {
      setIsPlaying(false);
    }
  }, [is_annkut_audio_playing]);

  // useEffect(() => {
  //   if (isFullScreen && currentVideoPlay === videoId) {

  //     dispatch(onPauseVideo());
  //     setIsPlaying(true);
  //     dispatch(setCurrentVideo(getSession(VIDEO_PLAYER.CURRENT_VIDEO) || null));
  //     if (playerRef.current && currentVideoPosition) {
  //       playerRef.current.seekTo(getSession(VIDEO_PLAYER.CURRENT_VIDEO_POSITION), "seconds");
  //     }
  //   }
  // }, [isFullScreen]);

  return (
    <div className="w-full mt-7 flex flex-col gap-3 relative">
      <div className="w-full flex flex-col-reverse justify-center items-center gap-8">
        <div
          className={cn(
            "w-full lg:w-[40%] max-lg:px-3 flex flex-col gap-2 justify-center items-center text-textColor/50 body_text_m font-baloobhai2Medium",
          )}
          dangerouslySetInnerHTML={{ __html: updatedBhajanHtml || bhajanHtml }}
        />
        <div className="w-full lg:w-[50%] flex gap-2 justify-center items-center">
          {/* <Suspense fallback={<div className="w-full aspect-video bg-gray-200 rounded-lg" />}> */}
          <ClientOnly
            fallback={
              <div className="w-full h-full  aspect-video bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center rounded-lg relative">
                <div className="flex flex-col items-center justify-center gap-4">
                  <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center animate-pulse">
                    <MdPlayArrow className="w-8 h-8 text-white" />
                  </div>
                  <p className="text-gray-400 text-sm font-medium">Loading player...</p>
                </div>
              </div>
            }
          >
            <div className="w-full aspect-video bg-gray-200 rounded-lg overflow-hidden">
              <ReactPlayer
                ref={playerRef}
                url={`${youtubeLinkPrefix}${videoId}`}
                width="100%"
                height="100%"
                controls
                playing={isPlaying}
                onPlay={handlePlayVideo}
                onPause={handlePauseVideo}
                onProgress={(progress) => {
                  dispatch(setCurrentVideoPosition(progress.playedSeconds));
                }}
              />
            </div>
          </ClientOnly>
          {/* </Suspense> */}
        </div>
      </div>
      <div className="max-md:hidden absolute top-0 left-20 2xl:left-36 w-auto h-full">
        <div className="w-auto sticky top-20 flex flex-col justify-start items-center gap-20">
          {Array.from({ length: 12 }).map((_, index) => (
            <div key={index} className="size-32 rounded-full">
              <img
                src={`https://legacy.swaminarayanbhagwan.org/wp-content/uploads/sb_uploads/thal/main_page_sidebar/sb${index + 10}.png`}
                alt="image"
                className="w-full h-full object-cover select-none"
              />
            </div>
          ))}
        </div>
      </div>
      <div className="max-md:hidden absolute top-0 right-20 2xl:right-36 w-auto h-full">
        <div className="w-auto sticky top-20 flex flex-col justify-start items-center gap-20">
          {Array.from({ length: 12 }).map((_, index) => (
            <div key={index} className="size-32 rounded-full">
              <img
                src={`https://legacy.swaminarayanbhagwan.org/wp-content/uploads/sb_uploads/thal/main_page_sidebar/sb${index + 1}.png`}
                alt="image"
                className="w-full h-full object-cover select-none"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RecipeBhajanView;
